'use client'

import { SessionProvider } from 'next-auth/react'
import { ReactNode } from 'react'

interface ProvidersProps {
  children: ReactNode
}

export function Providers({ children }: ProvidersProps) {
  return (
    <SessionProvider refetchInterval={300} refetchOnWindowFocus={true}>
      {children}
    </SessionProvider>
  )
}
